import styled from 'styled-components';
import RedInfoSvg from '../../assets/mytrips/red-info.svg';

const RedInfoIcon = styled(RedInfoSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.2rem'};
  height: ${props => props.height || '3.3rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default RedInfoIcon;
